// AUTH
export const AUTH_LOGIN_REQUEST = "AUTH_LOGIN_REQUEST";
export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";
export const AUTH_LOGIN_FAILURE = "AUTH_LOGIN_FAILURE";

export const AUTH_LOGOUT_REQUEST = "AUTH_LOGOUT_REQUEST";
export const AUTH_LOGOUT_SUCCESS = "AUTH_LOGOUT_SUCCESS";
export const AUTH_LOGOUT_FAILURE = "AUTH_LOGOUT_FAILURE";

export const AUTH_AUTHENTICATE_REQUEST = "AUTH_AUTHENTICATE_REQUEST";
export const AUTH_AUTHENTICATE_SUCCESS = "AUTH_AUTHENTICATE_SUCCESS";
export const AUTH_AUTHENTICATE_FAILURE = "AUTH_AUTHENTICATE_FAILURE";

export const AUTH_REFRESH_JWT_REQUEST = "AUTH_REFRESH_JWT_REQUEST";
export const AUTH_REFRESH_JWT_SUCCESS = "AUTH_REFRESH_JWT_SUCCESS";
export const AUTH_REFRESH_JWT_FAILURE = "AUTH_REFRESH_JWT_FAILURE";

export const AUTH_JWT_EXPIRED = "AUTH_JWT_EXPIRED";

// PROJECT
export const PROJECT_CREATE_REQUEST = "PROJECT_CREATE_REQUEST";
export const PROJECT_CREATE_SUCCESS = "PROJECT_CREATE_SUCCESS";
export const PROJECT_CREATE_FAILURE = "PROJECT_CREATE_FAILURE";
export const PROJECT_UPLOAD_DATASET_PROGRESS =
  "PROJECT_UPLOAD_DATASET_PROGRESS";

export const PROJECT_LIST_REQUEST = "PROJECT_LIST_REQUEST";
export const PROJECT_LIST_SUCCESS = "PROJECT_LIST_SUCCESS";
export const PROJECT_LIST_FAILURE = "PROJECT_LIST_FAILURE";

export const PROJECT_DELETE_REQUEST = "PROJECT_DELETE_REQUEST";
export const PROJECT_DELETE_SUCCESS = "PROJECT_DELETE_SUCCESS";
export const PROJECT_DELETE_FAILURE = "PROJECT_DELETE_FAILURE";

export const PROJECT_UPDATE_DURATION = "PROJECT_UPDATE_DURATION";

// DATASET
export const DATASET_PROCESS_SUCCESS = "DATASET_PROCESS_SUCCESS";
export const DATASET_PROCESS_FAILURE = "DATASET_PROCESS_FAILURE";

export const DATASET_DELETE_SUCCESS = "DATASET_DELETE_SUCCESS";
export const DATASET_DELETE_FAILURE = "DATASET_DELETE_FAILURE";

// RECORDINGS
export const RECORDING_LIST_REQUEST = "RECORDING_LIST_REQUEST";
export const RECORDING_LIST_SUCCESS = "RECORDING_LIST_SUCCESS";
export const RECORDING_LIST_FAILURE = "RECORDING_LIST_FAILURE";

export const RECORDING_GET_REQUEST = "RECORDING_GET_REQUEST";
export const RECORDING_GET_SUCCESS = "RECORDING_GET_SUCCESS";
export const RECORDING_GET_FAILURE = "RECORDING_GET_FAILURE";

export const RECORDING_UPDATE_REQUEST = "RECORDING_UPDATE_REQUEST";
export const RECORDING_UPDATE_SUCCESS = "RECORDING_UPDATE_SUCCESS";
export const RECORDING_UPDATE_FAILURE = "RECORDING_UPDATE_FAILURE";

export const RECORDING_BULK_UPDATE_REQUEST = "RECORDING_BULK_UPDATE_REQUEST";
export const RECORDING_BULK_UPDATE_SUCCESS = "RECORDING_BULK_UPDATE_SUCCESS";
export const RECORDING_BULK_UPDATE_FAILURE = "RECORDING_BULK_UPDATE_FAILURE";

export const RECORDING_REVIEW_REQUEST = "RECORDING_REVIEW_REQUEST";
export const RECORDING_REVIEW_SUCCESS = "RECORDING_REVIEW_SUCCESS";
export const RECORDING_REVIEW_FAILURE = "RECORDING_REVIEW_FAILURE";

export const RECORDING_ADD_LIST = "RECORDING_ADD_LIST";

// COMMENTS
export const COMMENT_LIST_REQUEST = "COMMENT_LIST_REQUEST";
export const COMMENT_LIST_SUCCESS = "COMMENT_LIST_SUCCESS";
export const COMMENT_LIST_FAILURE = "COMMENT_LIST_FAILURE";

export const COMMENT_CREATE_REQUEST = "COMMENT_CREATE_REQUEST";
export const COMMENT_CREATE_SUCCESS = "COMMENT_CREATE_SUCCESS";
export const COMMENT_CREATE_FAILURE = "COMMENT_CREATE_FAILURE";

// MODE
export const SWITCH_MODE = "SWITCH_MODE";

// MICROPHONE
export const TOGGLE_MIC = "TOGGLE_MIC";
export const MICROPHONE_SET = "MICROPHONE_SET";

// NOTIFY
export const NOTIFICATION_ADD = "NOTIFICATION_ADD";
export const NOTIFICATION_DELETE = "NOTIFICATION_DELETE";
